import { ModelsPage as SharedModelsPage } from '@trinetra/shared';
import { useNode } from '../contexts/NodeContext';

/** Cloud models are node-scoped; permission keys use the `ai-models.*` namespace. */
export default function ModelsPage() {
  const { selectedNode } = useNode();
  return (
    <SharedModelsPage
      requireNode
      nodeKey={selectedNode?.nodeId ?? null}
      permissions={{ add: 'ai-models.add', delete: 'ai-models.delete', attach: 'ai-models.assign' }}
    />
  );
}
